import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  dropdown: {
    '.ant-dropdown-menu .ant-dropdown-menu-item-icon': {
      fontSize: 16
    }
  }
}))
